import { MarkerType } from "@xyflow/react";

const defaultColumns = 4;
const defaultY = 400;
const defaultGap = 40;
const defaultWidth = 400;

export const createNodeRefs = (newdata, config, reset, mode, grefs) => {
  const nodeCollection = [];
  const edgeCollection = [];

  const markerEnd = {
    type: MarkerType[config.edges.marker.end.type],
    width: config.edges.marker.end.width,
    height: config.edges.marker.end.height,
    color: config.edges.marker.end.color,
  };

  const idStyle = { fontWeight: 400, fontSize: 8 };
  newdata.forEach((node, i) => {
    const nodeType = node["NodeType"].toLowerCase();

    if (nodeType) {
      if (i === 0) {
        grefs.startRef.current = node["Index"];
      }
      nodeCollection.push({
        id: node["Index"],
        data: node["NodeText"],
        type: nodeType,
        list: node["SelectList"] ? node["SelectList"] : "",
        hoverLabel: node["HoverLabel"] ? node["HoverLabel"] : null,
        hoverText: node["HoverText"] ? node["HoverText"] : null,
      });

      if (grefs.selectRef.current) {
        //create edge from  last select to start
        edgeCollection.push({
          type: config.edges.type,
          id: node["Index"] + "_E|" + Math.random(),
          source: grefs.selectRef.current,
          target: grefs.startRef.current,
          label: "",
          style: config.edges.lineStyle,
          markerEnd: markerEnd,
        });
      }
    }
    //If select then add a placeholder node
    if (nodeType === "select") {
      nodeCollection.push({
        id: `${node["Index"]}_placeholder`,
        data: "",
        type: "placeholder",
        list: "",
        hoverLabel: null,
        hoverText: null,
      });

      edgeCollection.push({
        type: config.edges.type,
        id: node["Index"] + "_E|" + Math.random(),
        source: node["Index"],
        target: `${node["Index"]}_placeholder`,
        label: "",
        style: config.edges.lineStyle,
      });
    }
    //add edges
    if (
      nodeType === "end" ||
      nodeType === "message" ||
      nodeType === "screenshot" ||
      nodeType === "start"
    ) {
      edgeCollection.push({
        type: config.edges.type,
        id: node["Index"] + "_E|" + Math.random(),
        source: node["Index"],
        target: node["YesTarget"],
        label: "",
        style: config.edges.lineStyle,
        markerEnd: markerEnd,
      });
    }

    if (nodeType === "question") {
      edgeCollection.push({
        type: config.edges.type,
        id: node["Index"] + "_E|" + Math.random(),
        source: node["Index"],
        target: node["YesTarget"],
        labelStyle: config.labels,
        style: config.edges.lineStyle,
        label: "Yes",
        labelBgStyle: config.labelBgStyleYes,
        labelBgBorderRadius: config.labelBgBorderRadius,
        labelBgPadding: config.labelBgPadding,
        markerEnd: markerEnd,
      });
      edgeCollection.push({
        type: config.edges.type,
        id: node["Index"] + "_E|" + Math.random(),
        source: node["Index"],
        target: node["NoTarget"],
        labelStyle: config.labels,
        style: config.edges.lineStyle,
        label: "No",
        labelBgStyle: config.labelBgStyleNo,
        labelBgBorderRadius: config.labelBgBorderRadius,
        labelBgPadding: config.labelBgPadding,
        markerEnd: markerEnd,
      });
    }
    if (
      !node["YesTarget"] &&
      nodeType !== "select" &&
      nodeType !== "question"
    ) {
      grefs.nodesWithoutSources.current[node["Index"]] = {};
    }
    if (!node["YesTarget"] && nodeType === "question") {
      grefs.questionsWithoutYes.current[node["Index"]] = {};
    }
    if (!node["NoTarget"] && nodeType === "question") {
      grefs.questionsWithoutNo.current[node["Index"]] = {};
    }
    if (!node["YesTarget"] && !node["NoTarget"] && nodeType === "question") {
      grefs.nodesWithoutSources.current[node["Index"]] = {};
    }
  });
  const edgeTargets = edgeCollection.map((edge) => edge.target);
  const edgeSources = edgeCollection.map((edge) => edge.source);

  const newNodes = nodeCollection.map((node, i) => {
    const property = grefs.positionRef.current.filter((pos) => {
      return pos.id === node.id;
    });

    const pos =
      property[0] && !reset
        ? property[0].position
        : {
            x: (defaultWidth + defaultGap) * (i % defaultColumns),
            y: defaultY * Math.floor(i / defaultColumns),
          };

    let hand = {};

    if (
      node.id === grefs.startRef.current &&
      grefs.selectRef.current &&
      mode === "flow"
    ) {
      //find placeholder target from last batch of handles
      let target = "Top";
      if (grefs.lastLayoutIdRef.current in grefs.keyHandleRef.current) {
        const plh = grefs.keyHandleRef.current[grefs.lastLayoutIdRef.current];
        const plhPos = Object.entries(plh).find((item) =>
          item[0].includes("_placeholder")
        );

        target = plhPos ? (plhPos[1] ? plhPos[1].target : "Top") : "Top";
      }
      hand = grefs.handleRef.current[node.id]
        ? {
            ...grefs.handleRef.current[node.id],
            target: target,
          }
        : {
            source: edgeSources.includes(node.id) ? "Bottom" : "",
            target: target,
          };
      grefs.selectRef.current = null;
    } else {
      hand = grefs.handleRef.current[node.id]
        ? grefs.handleRef.current[node.id]
        : {
            source: edgeSources.includes(node.id) ? "Bottom" : "",
            target: edgeTargets.includes(node.id) ? "Top" : "",
          };
    }

    return {
      id: node.id,
      data: {
        label: (
          <div style={{ backgroundColor: config[node.type].backgroundColor }}>
            <div style={{ display: "flex", gap: 2 }}>
              <div style={idStyle}>{node.id}</div>
              {/* <div style={idStyle}>{pos.x}</div>
              <div style={idStyle}>{pos.y}</div> */}
            </div>
            <div>{node.data}</div>
          </div>
        ),
        handles: hand,
        style: config[node.type],
        buttonStyle: config.buttons,
        popupStyle: config.popups,
        handleStyle: config.handles,
        id: node.id,
        type: node.type,
        list: node.list,
        hoverLabel: node.hoverLabel,
        hoverText: node.hoverText,
        layoutId: grefs.layoutIdRef.current,
        text: node.data,
      },
      position: pos,
      width: config[node.type].width ? config[node.type].width : defaultWidth,
      type:
        node.type === "start"
          ? "StartNode"
          : node.type === "placeholder"
          ? "PlaceholderNode"
          : "CustomNode",
      draggable: config.draggable,
      hidden: false,
    };
  });
  const newEdges = edgeCollection;

  if (mode === "flow") {
    grefs.keyNodeCollectionRef.current[grefs.layoutIdRef.current] = newNodes;
    grefs.keyEdgeCollectionRef.current[grefs.layoutIdRef.current] = newEdges;
    grefs.keyHandleRef.current[grefs.layoutIdRef.current] =
      grefs.handleRef.current;

    grefs.nodeCollectionRef.current = Object.values(
      grefs.keyNodeCollectionRef.current
    ).reduce((a, b) => {
      return a.concat(b);
    }, []);
    grefs.edgeCollectionRef.current = Object.values(
      grefs.keyEdgeCollectionRef.current
    ).reduce((a, b) => {
      return a.concat(b);
    }, []);
  } else {
    grefs.nodeCollectionRef.current = newNodes;
    grefs.edgeCollectionRef.current = newEdges;
  }
};
